module.exports = __webpack_public_path__ + "img/na-caribbean-custom.140fb90e.png";